<template>
  <div class="pricing-table-item-wrapper">
    <details class="pricing-table-item" v-if="description">
      <summary class="pricing-table-item__title">
        <span class="pricing-table-item__title__inner">
          <ChevronIcon class="item-icon" color="gray400" size=".8em" />
          <span>
            <slot />
          </span>
        </span>
      </summary>
      <div class="pricing-table-item__content">{{ description }}</div>
    </details>
    <slot v-else />
  </div>
</template>

<script>
import { ChevronIcon, FlexSpacer } from '@campsite-bio/component-lib';

export default {
  components: {
    ChevronIcon,
    FlexSpacer,
  },

  props: {
    description: String,
    to: String,
  },

  setup() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.pricing-table-item-wrapper {
  font-size: 0.9rem;

  @media (min-width: 768px) {
    font-size: 1rem;
  }
}

.pricing-table-item {
  font-size: 0.85rem;

  &[open] .pricing-table-item__title {
    .item-icon {
      transform: rotate(180deg);
    }
  }

  &__title {
    cursor: pointer;
    list-style: none;
    font-size: 1.05rem;

    @media (min-width: 768px) {
      font-size: 1rem;
    }

    &:hover {
      .item-icon {
        transform: translateY(8%);
      }
    }

    &::-webkit-details-marker {
      display: none;
    }

    &__inner {
      align-items: center;
      display: flex;
      gap: 0.5rem;
    }

    .item-icon {
      font-size: 1.25em;
      transition: all var(--g-transition-speed);
    }
  }

  &__content {
    padding-left: 1.8rem;
    padding-top: 0.5rem;
  }
}
</style>
